import React from "react";
import { Box, Typography } from "@mui/material";
import InfoIcon from "../../../../../common/components/icons/InfoIcon";

const TimeZoneInformator = ({ timeZone }: { timeZone: string }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "0.5em",
        marginTop: "0.5em",
      }}
    >
      <InfoIcon />

      <Typography
        sx={{
          display: "block",
          color: theme => theme.palette.text.secondary,
          fontWeight: 400,
        }}
      >
        All times in local facility time - {` `}
        <Typography component="span" sx={{ fontWeight: 500 }}>
          {timeZone}
        </Typography>
      </Typography>
    </Box>
  );
};

export default React.memo(TimeZoneInformator);
